import React from 'react';
import { useSelector } from 'react-redux';

const Security = () => {
  const language = useSelector((state) => state.language);

  return (
    <div className={`min-h-screen bg-gradient-to-br from-white via-blue-50 to-indigo-50 py-20 px-4`} dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          {language === "ar" ? "الأمان والحماية" : language === "fr" ? "Sécurité" : "Security"}
        </h1>

        <div className="bg-white rounded-xl shadow-lg p-8 space-y-6 text-gray-700">
          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "مبادئنا الأمنية" : language === "fr" ? "Nos principes de sécurité" : "Our Security Principles"}
            </h2>
            <p className="leading-relaxed">
              {language === "ar"
                ? "الأمان هو في قلب كل ما نفعله في RAQIB. نحن نتخذ نهجاً متعدد الطبقات لحماية البيانات والأنظمة."
                : language === "fr"
                ? "La sécurité est au cœur de tout ce que nous faisons chez RAQIB. Nous adoptons une approche multicouche pour protéger les données et les systèmes."
                : "Security is at the heart of everything we do at RAQIB. We take a multi-layered approach to protecting data and systems."}
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "تشفير البيانات" : language === "fr" ? "Chiffrement des données" : "Data Encryption"}
            </h2>
            <ul className="space-y-3 ml-4">
              <li className="flex items-start">
                <span className="text-teal-500 mr-3 font-bold">▪</span>
                <span>
                  {language === "ar"
                    ? "تشفير AES-256 للبيانات المخزنة في الحالة السكونية"
                    : language === "fr"
                    ? "Chiffrement AES-256 pour les données au repos"
                    : "AES-256 encryption for data at rest"}
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-500 mr-3 font-bold">▪</span>
                <span>
                  {language === "ar"
                    ? "TLS 1.3 لجميع البيانات المنقولة"
                    : language === "fr"
                    ? "TLS 1.3 pour toutes les données en transit"
                    : "TLS 1.3 for all data in transit"}
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-500 mr-3 font-bold">▪</span>
                <span>
                  {language === "ar"
                    ? "إدارة المفاتيح الآمنة والتناوب المنتظم"
                    : language === "fr"
                    ? "Gestion sécurisée des clés et rotation régulière"
                    : "Secure key management and regular rotation"}
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "المصادقة والتحكم في الوصول" : language === "fr" ? "Authentification et contrôle d'accès" : "Authentication and Access Control"}
            </h2>
            <ul className="space-y-3 ml-4">
              <li className="flex items-start">
                <span className="text-teal-500 mr-3 font-bold">▪</span>
                <span>
                  {language === "ar"
                    ? "المصادقة متعددة العوامل (MFA)"
                    : language === "fr"
                    ? "Authentification multifacteur (MFA)"
                    : "Multi-Factor Authentication (MFA)"}
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-500 mr-3 font-bold">▪</span>
                <span>
                  {language === "ar"
                    ? "التحكم في الوصول القائم على الأدوار (RBAC)"
                    : language === "fr"
                    ? "Contrôle d'accès basé sur les rôles (RBAC)"
                    : "Role-Based Access Control (RBAC)"}
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-500 mr-3 font-bold">▪</span>
                <span>
                  {language === "ar"
                    ? "سجلات التدقيق الشاملة لجميع الأنشطة"
                    : language === "fr"
                    ? "Journaux d'audit complets pour toutes les activités"
                    : "Comprehensive audit logs for all activities"}
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "الاختبار والمراقبة" : language === "fr" ? "Essais et surveillance" : "Testing and Monitoring"}
            </h2>
            <ul className="space-y-3 ml-4">
              <li className="flex items-start">
                <span className="text-teal-500 mr-3 font-bold">▪</span>
                <span>
                  {language === "ar"
                    ? "اختبارات الاختراق المنتظمة"
                    : language === "fr"
                    ? "Tests de pénétration réguliers"
                    : "Regular penetration testing"}
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-500 mr-3 font-bold">▪</span>
                <span>
                  {language === "ar"
                    ? "المراقبة المستمرة للتهديدات"
                    : language === "fr"
                    ? "Surveillance continue des menaces"
                    : "Continuous threat monitoring"}
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-500 mr-3 font-bold">▪</span>
                <span>
                  {language === "ar"
                    ? "فحوصات التعرض الدورية"
                    : language === "fr"
                    ? "Contrôles de vulnérabilité périodiques"
                    : "Periodic vulnerability scans"}
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-500 mr-3 font-bold">▪</span>
                <span>
                  {language === "ar"
                    ? "خطة الاستجابة للحوادث"
                    : language === "fr"
                    ? "Plan de réponse aux incidents"
                    : "Incident response plan"}
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "الامتثال والشهادات" : language === "fr" ? "Conformité et certifications" : "Compliance and Certifications"}
            </h2>
            <ul className="space-y-3">
              <li className="flex items-center">
                <span className="text-green-500 mr-3 font-bold">✓</span>
                <span>SOC 2 Type II Certified</span>
              </li>
              <li className="flex items-center">
                <span className="text-green-500 mr-3 font-bold">✓</span>
                <span>HIPAA Compliant</span>
              </li>
              <li className="flex items-center">
                <span className="text-green-500 mr-3 font-bold">✓</span>
                <span>ISO 27001 Certified</span>
              </li>
              <li className="flex items-center">
                <span className="text-green-500 mr-3 font-bold">✓</span>
                <span>GDPR Compliant</span>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "الإفصاح عن الثغرات" : language === "fr" ? "Divulgation de vulnérabilités" : "Vulnerability Disclosure"}
            </h2>
            <p className="leading-relaxed mb-4">
              {language === "ar"
                ? "إذا اكتشفت ثغرة أمنية في RAQIB، فيرجى الإبلاغ عنها بشكل مسؤول:"
                : language === "fr"
                ? "Si vous découvrez une faille de sécurité dans RAQIB, veuillez la signaler de manière responsable:"
                : "If you discover a security vulnerability in RAQIB, please report it responsibly:"}
            </p>
            <div className="bg-gray-100 p-4 rounded font-mono text-sm">
              security@raqibapp.com
            </div>
          </div>

          <div className="bg-teal-50 border-l-4 border-teal-500 p-4 rounded">
            <p className="text-sm text-gray-700">
              {language === "ar"
                ? "نقدم مكافآت الأمان للباحثين الذين يبالغون عن الثغرات بشكل مسؤول. شكراً لمساعدتك في الحفاظ على أمان RAQIB."
                : language === "fr"
                ? "Nous offrons des récompenses de sécurité aux chercheurs qui signalent les vulnérabilités de manière responsable."
                : "We offer security rewards to researchers who responsibly disclose vulnerabilities. Thank you for helping keep RAQIB secure."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Security;
